[
  {
    "id": "warrior",
    "name": "Warrior",
    "primary": "str",
    "hpBonusPct": 40,
    "baseStats": {
      "str": 14,
      "dex": 8,
      "int": 5,
      "vit": 12
    },
    "weapon": {
      "name": "Training Sword",
      "apBase": 10,
      "attackIntervalMs": 2000,
      "range": 3
    },
    "starterItems": [
      {
        "item": "rusty_sword",
        "equip": "weapon"
      }
    ],
    "levelHp": 3500,
    "levelMp": 700,
    "levelAp": 300,
    "mpCostRef": 367
  },
  {
    "id": "rogue",
    "name": "Rogue",
    "primary": "dex",
    "hpBonusPct": 10,
    "baseStats": {
      "str": 8,
      "dex": 14,
      "int": 5,
      "vit": 10
    },
    "weapon": {
      "name": "Training Daggers",
      "apBase": 8,
      "attackIntervalMs": 1300,
      "range": 3
    },
    "starterItems": [
      {
        "item": "worn_daggers",
        "equip": "weapon"
      }
    ],
    "levelHp": 2800,
    "levelMp": 800,
    "levelAp": 300,
    "mpCostRef": 333
  },
  {
    "id": "mage",
    "name": "Mage",
    "primary": "int",
    "hpBonusPct": 0,
    "baseStats": {
      "str": 5,
      "dex": 8,
      "int": 15,
      "vit": 9
    },
    "weapon": {
      "name": "Training Staff",
      "apBase": 8,
      "attackIntervalMs": 2200,
      "range": 3
    },
    "starterItems": [
      {
        "item": "ash_staff",
        "equip": "weapon"
      }
    ],
    "levelHp": 1800,
    "levelMp": 2400,
    "levelAp": 300,
    "mpCostRef": 667
  },
  {
    "id": "priest",
    "name": "Priest",
    "primary": "int",
    "hpBonusPct": 15,
    "baseStats": {
      "str": 8,
      "dex": 6,
      "int": 13,
      "vit": 12
    },
    "weapon": {
      "name": "Training Mace",
      "apBase": 9,
      "attackIntervalMs": 1800,
      "range": 3
    },
    "starterItems": [
      {
        "item": "wooden_mace",
        "equip": "weapon"
      }
    ],
    "levelHp": 3000,
    "levelMp": 1800,
    "levelAp": 260,
    "mpCostRef": 800
  }
]
